import React, { useState } from 'react';
import { Form, Table } from 'react-bootstrap';
import IconAlert from 'components/common/IconAlert';

const OneDPSPersonnel = ({
    staffing,
}) => {
    const [showTable, setShowTable] = useState(false)
    return (<>
        
        
        {showTable ?
            <Table size='sm'>
                <thead>
                    <tr key={'entete'}>
                        <th>Nom</th>
                        <th>Prénom</th>
                    </tr>
                </thead>
                <tbody>
                    {staffing.map((personne, i)=>{return(
                        <tr key={'personne'+i}>
                            <td>{personne.nomIS}</td>
                            <td>{personne.prenomIS}</td>
                        </tr>
                    )})}
                </tbody>
            </Table>
        :
            <IconAlert variant={'warning'}>
                De par vos besoins opérationnels, vous avez été habilité(e) à accéder à la liste nominative des intervenants présents sur le DPS. Nous vous rappelons que cette liste est confidentielle, à usage interne uniquement.<br/>
                <Form.Check 
                    key="showTable"
                    type='switch'
                    id="showTable"
                    label="J'ai lu et compris l'avertissement"
                    name='showTable'
                    checked={showTable}
                    onChange={(e)=>{setShowTable(e.target.checked)}}
                />
            </IconAlert>
        }
    </>);
};

OneDPSPersonnel.propTypes = {};

export default OneDPSPersonnel;
